module.exports = __webpack_public_path__ + "static/media/carousel-body-three-image.90e9607d.png";